import { alertLabels } from '@/parcels/constants'

import { parcelTimelineEventTypes } from './constants'

export const getParcelTimelineEvents = (parcel, t) => {
  return parcel?.timeline_events?.map(event => {
    if (event.type === parcelTimelineEventTypes.parcelCreated) {
      return { ...event, properties: { ...event.properties, order: parcel.order } }
    }

    if (event.type === parcelTimelineEventTypes.parcelUpdated) {
      return { ...event, properties: { ...event.properties, text: t(alertLabels[event.alert_type]) } }
    }

    return event
  })
}

export const mapUserToAtValue = user => ({
  id: user.id,
  value: user.username,
  first_name: user.first_name,
  last_name: user.last_name,
  profile_picture_url: user.profile_picture_url,
})
